import React from "react";

const BackendAnalytics = () => {
    return (
        <div>Backend Panel</div>
    );
};

export default BackendAnalytics